/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const en_search_results_load_more21 = /** @type {(inputs: {}) => string} */ () => {
	return `Load more`
};

const fr_search_results_load_more21 = /** @type {(inputs: {}) => string} */ () => {
	return `Afficher plus`
};

const de_search_results_load_more21 = /** @type {(inputs: {}) => string} */ () => {
	return `Mehr laden`
};

const es_search_results_load_more21 = /** @type {(inputs: {}) => string} */ () => {
	return `Carga más`
};

const it_search_results_load_more21 = /** @type {(inputs: {}) => string} */ () => {
	return `Carica di più`
};

const ar_search_results_load_more21 = /** @type {(inputs: {}) => string} */ () => {
	return `تحميل المزيد`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "fr" | "de" | "es" | "it" | "ar" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const search_results_load_more21 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.search_results_load_more21(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("search_results_load_more21", locale)
	if (locale === "en") return en_search_results_load_more21(inputs)
	if (locale === "fr") return fr_search_results_load_more21(inputs)
	if (locale === "de") return de_search_results_load_more21(inputs)
	if (locale === "es") return es_search_results_load_more21(inputs)
	if (locale === "it") return it_search_results_load_more21(inputs)
	return ar_search_results_load_more21(inputs)
};
export { search_results_load_more21 as "SEARCH_RESULTS_LOAD_MORE" }